import __ from "web/Layout/Translations";

const ErrorComponent = () => <>{__("Błąd pobierania danych")}</>;
const ErrorComponentWithContainer = () => (
  <div className="container">{__("Błąd pobierania danych")}</div>
);

export default ErrorComponent;
export { ErrorComponentWithContainer };
